export default "__VITE_ASSET__DVBdsDvD__"